module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAACXBIWXMAAAsSAAALEgHS3X78AAABF0lEQVRIib3WsW3DMBBA0W9NkBHcM4UBtS68QIKM4DqVRwmSBTyFay1AQM1tkl5pxESxJfLuRJuVcKD0cCTvxM0wDDx6NOkhhHZ7TyiE9ikZzRg4AH0I7e5eINABp19UJKZAVxuegL1I/ENH+FwbvgKPKd5MJ9WEl8AbtBacA2fRtXAJXES9sAbMolZYCxZRLWwBVWgJtoJqdAn2gAAba8MPoT0CH8AL8GUFXegIvwOfwEUkvlrf92SalvQbeAYOIrG3fEO9p1dgLxL3OBuIGp07NN7OpUJzp9QDF1FNWVjhLGqpQwu8iHoKXwvPot5Oo4Vv0DWgFv6H1gA18PTeWw0sweneWx3MwSnTLdDVBmfgN3D+ZdaOH7Ki/LBowM5UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/component/header/images/icon_close.png
// module id = 128
// module chunks = 4